goog.provide('el8.appchart.visitNote.exportProblemsDialog');

goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.appchart.visitNote.exportProblemsDialog');

/**
 * Displays a list of patient problems and provides a convenient way to
 * select and export problems to the visit note.
 */
el8.appchart.visitNote.exportProblemsDialog = (function() {

    var that = new el8.uiwidget.NewDialog({
        title: 'Export Problems to Visit Note',
        autoHeight: true,
        width: 400,
        modal: true,
        position: 'center',
        contentFn: function() {
            return el8.template.appchart.visitNote.exportProblemsDialog.content({
                headerText: 'Select problems to export to visit note'
            });
        },
        showXButton: true
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that.getContentElt().on('click', 'button[name="export-to-note-button"]',  function(e) {
            $.each($('input[name="problem-checkbox"]:checked', that.getContentElt()), function() {
                var patientProblem = el8.ptdata.ptProblems.getById($(this).val());
                el8.appchart.mgr.notes.addProblemWithDetails(patientProblem);
                if (el8.appchart.actions.problems.isHpiAComboExportRelevant()) {
                    el8.appchart.mgr.notes.addReference({item: patientProblem });
                }
            });
            that.hide();
        });
    };

    var super_show = that.show;
    that.show = function(ptProblems, title, heading) {
        super_show.call(that);
        ptProblems = ptProblems || el8.ptdata.ptProblems.all();
        if (title) { that.setTitle(title); }
        if (heading) { $('.sectionTopHeader', that.getContentElt()).text(heading); }

        $('.problems-list', that.getContentElt()).html(
            el8.template.appchart.visitNote.exportProblemsDialog.problemsList({
                problems: ptProblems.map(function(p) { return p.asSoyMap(); }),
                hccScoringEnabled: el8.data.practiceSettings.isHccScoringEnabled(),
                defaultChecked: true
            })
        );
        $('button[name="export-to-note-button"]', that.getContentElt()).html(
            'Export to Note (' +
            (el8.appchart.actions.problems.isHpiAComboExportRelevant() ? 'HPI, A' : 'A') +
            (el8Globals['FEATURES']['AutoImportBilling'] ? ', Billing' : '') +
            ')'
        );
        that.adjustPosition();
    };

    return that;

})();
